
import { ApplicationUserModel, ProductCollectionModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { productCollectionsStore } from '@/libs/products/+state/store';

@Component({})
export default class ProductCollectionDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    productCollection: ProductCollectionModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.productCollection?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadProductCollection()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        reject(e);
                    });
            });
        } else {
            this.productCollection = {
                id: Guid.EmptyGuid(),
                name: null,
                scrapCosts: null,
            } as ProductCollectionModel;
            return new Promise((resolve) => resolve(null));
        }
    }

    private loadProductCollection() {
        return new Promise((resolve, reject) => {
            productCollectionsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(productCollectionsStore, CrudReponse.Get)
                .then((e) => {
                    this.productCollection = e;
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const productCollection = { ...this.productCollection } as ProductCollectionModel;
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                productCollectionsStore.dispatch(CrudAction.Create, { item: productCollection });
                this.subscribe(productCollectionsStore, CrudReponse.Create)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                productCollectionsStore.dispatch(CrudAction.Update, { item: productCollection });
                this.subscribe(productCollectionsStore, CrudReponse.Update)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteProductCollection() {
        this.deleting = true;
        productCollectionsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(productCollectionsStore, CrudReponse.Delete)
            .then(() => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch(() => {
                this.deleting = false;
            });
    }
}
